import type { FormProps } from 'antd'

export const commonFormProps: FormProps = {
  colon: false,
  layout: 'vertical',
}

export const onFilterSelect = (input: string, option: any) =>
  option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
